const CATALOGUE_TYPE_ID = 10;
const REFUND_TYPE_ID = 9;
const REFUND_COMPARISON_TOLERANCE = 0.005;

const getItemBalance = item => {
  const quantity =
    item?.typeId === CATALOGUE_TYPE_ID ? Number(item?.quantity) || 1 : 1;
  return (
    (Number(item?.amount || 0) -
      Number(item?.discount || 0) +
      Number(item?.taxAmount || 0)) *
    quantity
  );
};

const calculateRefundableReceiptAmount = ({ items = [], payTypes = [] }) => {
  const receiptTypeIds = new Set(
    payTypes
      .filter(payType => Number(payType?.receipt) === -1)
      .map(payType => payType?.numberId),
  );
  const receiptCredit = Math.max(
    -items
      .filter(item => receiptTypeIds.has(item?.typeId))
      .reduce((total, item) => total + getItemBalance(item), 0),
    0,
  );
  const refunded = Math.max(
    items
      .filter(item => item?.typeId === REFUND_TYPE_ID)
      .reduce((total, item) => total + Number(item?.amount || 0), 0),
    0,
  );

  return Math.max(receiptCredit - refunded, 0);
};

export { calculateRefundableReceiptAmount, REFUND_COMPARISON_TOLERANCE };
